"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTable = void 0;
var core_1 = require("@material-ui/core");
var debounce_1 = require("debounce");
var react_1 = __importStar(require("react"));
var TTableContent_1 = require("./TTableContent");
var columnDataToInstance_1 = require("./utils/columnDataToInstance");
var defaultVisibleSettings = {
    isWithPresets: true,
    isWithAddCustomColumns: true,
    isWithFilters: true,
    isWithCollapseRowMode: true,
    isWithDraggableColumns: true,
    isWithColumnMenu: true,
};
var TTable = function (props) {
    var visibleSettings = props.visibleSettings, defaultColumns = props.defaultColumns, fetchData = props.fetchData, fetchColumns = props.fetchColumns, registryCode = props.registryCode, lang = props.lang, fetchCatalog = props.fetchCatalog, fetchSelectDataByUrl = props.fetchSelectDataByUrl, cellFormatters = props.cellFormatters, customFilters = props.customFilters, saveListPresets = props.saveListPresets, fetchUserRoleList = props.fetchUserRoleList, upload = props.upload, isAdmin = props.isAdmin, otherSettings = __rest(props, ["visibleSettings", "defaultColumns", "fetchData", "fetchColumns", "registryCode", "lang", "fetchCatalog", "fetchSelectDataByUrl", "cellFormatters", "customFilters", "saveListPresets", "fetchUserRoleList", "upload", "isAdmin"]);
    var settingsOptionsTTable = __assign(__assign({}, defaultVisibleSettings), visibleSettings);
    var defaultCols = defaultColumns || [];
    var _a = react_1.useState({ rows: [], count: 0 }), rowsData = _a[0], setRowsData = _a[1];
    var _b = react_1.useState(), customColumns = _b[0], setCustomColumns = _b[1];
    react_1.useEffect(function () {
        if (fetchColumns) {
            fetchColumns(registryCode).then(setCustomColumns);
        }
    }, [fetchColumns, setCustomColumns, registryCode]);
    var columns = react_1.useMemo(function () {
        if (fetchColumns && customColumns) {
            return __spreadArrays(defaultCols, columnDataToInstance_1.columnDataToInstance(customColumns, lang, fetchCatalog, fetchSelectDataByUrl, cellFormatters, customFilters));
        }
        return defaultCols;
    }, [defaultCols, customColumns, fetchCatalog, fetchSelectDataByUrl, lang, cellFormatters]);
    var handleFetchData = react_1.useCallback(debounce_1.debounce(function (query, then) {
        return fetchData(registryCode, query).then(setRowsData).then(then);
    }, 500), [fetchData, setRowsData, registryCode]);
    var renderWithFetchedColumns = react_1.useCallback(function () {
        return customColumns ? (react_1.default.createElement(TTableContent_1.TTableContent, __assign({ registryCode: registryCode, data: rowsData, columns: columns, onFetchData: handleFetchData, manualSortBy: true, manualFilters: true, manualPagination: true, lang: lang, saveListPresets: saveListPresets, fetchUserRoleList: fetchUserRoleList, upload: upload, isAdmin: isAdmin, visibleSettings: settingsOptionsTTable }, otherSettings))) : (react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center", justify: "center" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.CircularProgress, null))));
    }, [customColumns, registryCode, rowsData, columns, settingsOptionsTTable, handleFetchData, lang, otherSettings]);
    return fetchColumns ? (renderWithFetchedColumns()) : (react_1.default.createElement(TTableContent_1.TTableContent, __assign({ registryCode: registryCode, data: rowsData, columns: columns, onFetchData: handleFetchData, manualSortBy: true, manualFilters: true, manualPagination: true, lang: lang, saveListPresets: saveListPresets, fetchUserRoleList: fetchUserRoleList, upload: upload, isAdmin: isAdmin, visibleSettings: settingsOptionsTTable }, otherSettings)));
};
exports.TTable = TTable;
